import * as React from "react";

function SvgHeart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 473.13" {...props}>
      <path d="M471.89 39c-24.45-25.14-59.3-39-98.12-39C321 0 280.26 23 256 66.49 231.74 23 191 0 138.23 0 99.41 0 64.56 13.84 40.11 39 14.2 65.62.5 104 .5 149.88c0 54 41.37 123.5 123 206.59a1269.13 1269.13 0 00119.81 106.9l12.69 9.76 12.74-9.76a1269.13 1269.13 0 00119.81-106.9c81.58-83.09 123-152.6 123-206.59 0-45.91-13.7-84.26-39.61-110.9zm-112.6 292.37c-41.24 42-83 77-103.29 93.48-20.34-16.46-62.05-51.44-103.29-93.48C79.25 256.49 40.42 193.73 40.42 149.88c0-69.7 37.48-113 97.81-113 37 0 64.52 15.33 81.74 45.57 12.88 22.62 15.69 46 16.07 49.74v2.46H276v-2.45c.38-3.71 3.19-27.12 16.07-49.74 17.22-30.23 44.72-45.57 81.74-45.57 60.33 0 97.81 43.29 97.81 113 0 43.85-38.83 106.61-112.29 181.49z" />
    </svg>
  );
}

export default SvgHeart;
